import { render, staticRenderFns } from "./StrategicAllocationNewDate.vue?vue&type=template&id=3a3e0342&scoped=true"
import script from "./StrategicAllocationNewDate.vue?vue&type=script&lang=ts"
export * from "./StrategicAllocationNewDate.vue?vue&type=script&lang=ts"
import style0 from "./StrategicAllocationNewDate.vue?vue&type=style&index=0&id=3a3e0342&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3e0342",
  null
  
)

export default component.exports